import { IdentificationBehaviourDto } from '../../../interfaces/dtos/IdentificationBehaviourDto';
import { IdentificationDto } from '../../../interfaces/dtos/IdentificationDto';
import { Identification } from '../../../interfaces/Identification';

export default function transformIdentification(dto: IdentificationDto, behaviours: IdentificationBehaviourDto): Identification {
  return {
    birthDate: dto.birthDate,
    firstName: dto.firstName,
    gender: dto.gender,
    initials: dto.initials,
    isProspect: dto.isProspect,
    lastName: dto.lastName,
    careOf: dto.careOf,
    behaviours: {
      isClient: behaviours.isClient,
      showDateOfBirth: behaviours.showDateOfBirth,
      showGender: behaviours.showGender,
      showInitial: behaviours.showInitial,
      showSection: behaviours.showSection,
    },
  };
}
